module.exports = __webpack_public_path__ + "static/media/ui-library-patterns.62487f47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hubspot/ui-library-patterns.png
// module id = 965
// module chunks = 0